import { Box, Tab, Tabs } from '@mui/material';
import type { TabDef } from './useUrlTab';

/** Underlined page tabs that scroll on phones. */
export function PageTabs<T extends string>({
  tabs,
  value,
  onChange,
}: {
  tabs: TabDef<T>[];
  value: T;
  onChange: (t: T) => void;
}) {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2.5 }} className="no-print">
      <Tabs
        value={value}
        onChange={(_, v: T) => onChange(v)}
        variant="scrollable"
        allowScrollButtonsMobile
        sx={{
          minHeight: 44,
          '& .MuiTab-root': {
            minHeight: 44,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.9rem',
            px: 1.5,
            mr: 1,
          },
        }}
      >
        {tabs
          .filter((t) => t.show !== false)
          .map((t) => (
            <Tab key={t.value} value={t.value} label={t.label} />
          ))}
      </Tabs>
    </Box>
  );
}
